import { createAnalyticsClient } from './client';
import { resolveContext } from './context';
import { trackAnalyticsEvents } from '@/api/api';

export { stepLabel } from './stepLabel';

const OPTOUT_KEY = 'eauget_analytics_optout';

function isOptedOut(): boolean {
  try {
    if (localStorage.getItem(OPTOUT_KEY) === '1') return true;
    const dnt = (navigator as unknown as { doNotTrack?: string }).doNotTrack;
    return dnt === '1';
  } catch { return false; }
}

const context = resolveContext({
  viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
  referrer: typeof document !== 'undefined' ? document.referrer : '',
  search: typeof window !== 'undefined' ? window.location.search : '',
});

export const analytics = createAnalyticsClient({
  store: localStorage,
  context,
  now: () => Date.now(),
  send: (events) => trackAnalyticsEvents(events),
  isOptedOut,
  flushThreshold: 10,
});

let started = false;
export function initAnalytics(): void {
  if (started) return;
  started = true;
  // Flush on tab-hide / unload so the last step before abandonment is captured.
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') analytics.flush();
    });
  }
  if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', () => analytics.flush());
  }
}
